import { ClassificationCode } from "@/types/code.types";
import { ArticleInfo } from "@interface/articleInfo.interface";

import { ArticleInfoResponse } from "./articleInfo.interface";

export const adaptArticleInfoData = (
  info: ArticleInfoResponse,
): ArticleInfo => {
  if (info?.labelId || info?.classificationManual === "regulatoryLabel") {
    return {
      ...info,
      classification: info.classification,
      classificationAi:
        (info.classificationAi as ClassificationCode) || "regulatoryLabel",
      classificationManual:
        (info.classificationManual as ClassificationCode) || "regulatoryLabel",
      classificationAiName: info.classificationAiName,
      classificationManualName: info.classificationManualName,
      pressTitle: info?.labelName || info?.pressTitle || "",
      pressUrl: info?.pressUrl || "",
      isReviewRequired: false,
      reviewIdList: [],
    };
  }

  if (info?.publicationNumber || info?.classificationManual === "patent") {
    return {
      ...info,
      classification: info.classification,
      classificationAi:
        (info.classificationAi as ClassificationCode) || "patent",
      classificationManual:
        (info.classificationManual as ClassificationCode) || "patent",
      classificationAiName: info.classificationAiName,
      classificationManualName: info.classificationManualName,
      pressTitle: info?.title || info?.pressTitle || "",
      pressUrl: info?.pressUrl || "",
      isReviewRequired: false,
      reviewIdList: [],
    };
  }

  if (info?.publicationId) {
    return {
      ...info,
      affiliation:
        info.affiliation.filter((data) => data !== "")?.join(", ") || "",
      classificationAi: (info.topicType as ClassificationCode) || "P999",
      classificationManual: (info.topicType as ClassificationCode) || "P999",
      classificationAiName: "Publication",
      classificationManualName: "Publication",
      pressTitle: info?.title || "",
      pressUrl: info?.publicationUrl || "",
    };
  }

  if (info?.registryUrl || info?.registryDate) {
    return {
      ...info,
      pressTitle: info?.title || "",
      pressUrl: info?.registryUrl || "",
      classificationAi: info.registryAgency as ClassificationCode,
      classificationManual: info.registryAgency as ClassificationCode,
      id: info.id,
      registryId: info.registryId,
      registryDate: info.registryDate,
      registryAgency: info.registryAgency,
    };
  }
  const targetReviewRequiredInformationList =
    info?.reviewInformationList?.filter(({ deleted }) => deleted !== true);

  return {
    ...info,
    reviewIdList:
      targetReviewRequiredInformationList?.map((data) =>
        Number(data.reviewId),
      ) || [],
    isReviewRequired: targetReviewRequiredInformationList?.length > 0,
  };
};
